module.exports = __webpack_public_path__ + "static/media/bg.85a49deb.png";